import axios from 'axios';

export class HealthApiService {
  private async checkService(baseUrl: string): Promise<boolean> {
    const url = `${baseUrl}/api/v1/home/online`;
    try {
      const result = await axios.get<{ isOnline: boolean }>(url);
      return result?.data?.isOnline === true;
    } catch {
      return false;
    }
  }

  public async waitForHealthyBackendServices(options: { tries: number; waitSec: number } = { tries: 10, waitSec: 2 }) {
    let left = Math.max(options?.tries ?? 10, 10);
    const sec = Math.max(options?.waitSec ?? 2, 2);

    const servicesOnline = [false, false];

    while (left > 0 && servicesOnline.some((x) => !x)) {
      left--;
      if (!servicesOnline[0]) {
        servicesOnline[0] = await this.checkService(window.REACT_APP_IDENTITY_BASE_URI as string);
        console.log(servicesOnline[0] ? 'identity backend online' : 'identity backend down');
      }
      if (!servicesOnline[1]) {
        servicesOnline[1] = await this.checkService(window.REACT_APP_API_BASE_URI as string);
        console.log(servicesOnline[1] ? 'website backend online' : 'website backend down');
      }
      if (servicesOnline.every((x) => x)) {
        console.log('all backend services are online');
        return;
      }
      await this.wait(sec);
    }

    console.error('some backend services are down');
    throw new Error('some backend services are down');
  }

  private wait(sec: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, sec * 1000));
  }
}
